module.exports = (__webpack_require__(64628))(96540);